export class Productlist {
    id:number;
    name:string;
    name_ar:string;
    slug:string;
    image:string;
    price:number;
    currency:string;
    description:string;
    description_ar:string;
    pslug:string;
    wishListid:string;
    out_stock:number;
    pQty:number;
    isFeast:number;
    parentcatId:number;
    isRestricted:any;
      
    constructor(id:number, name:string, name_ar:string, slug:string, image:string, price:number, currency:string, description:string, description_ar:string, pslug:string,wishListid:string, out_stock:number, pQty:number, isFeast:number, parentcatId:number,isRestricted:any){
        this.id = id;
        this.name = name;
        this.name_ar = name_ar;
        this.slug = slug;
        this.image = image;
        this.price= price;
        this.currency = currency;
        this.description = description;
        this.description_ar = description_ar;
        this.pslug = pslug;
        this.wishListid = wishListid;
        this.out_stock = out_stock;
        this.pQty = pQty;
        this.isFeast = isFeast;
        this.parentcatId = parentcatId;
        this.isRestricted = isRestricted;
        
    }
}
